import ProProfileContent from './ProProfileContent.container';

export default ProProfileContent;
